let uniqueIdCounter = 0;
/**
 * Generates a unique ID based on incrementing a counter.
 */
export function uniqueId(prefix = "") {
    return `${prefix}${uniqueIdCounter++}`;
}
/**
 * Builds a string from a format specifier and replacement parameters.
 */
export function format(formatSpecifier, ...parameters) {
    return formatSpecifier.replace(/{(\d+)}/g, function (match, index) {
        if (index >= parameters.length) {
            return match;
        }
        const value = parameters[index];
        if (typeof value !== "number" && !value) {
            return "";
        }
        return value;
    });
}
/**
 * Check to see if one string starts with another
 */
export function startsWith(stringToSearch, searchFor, position = 0) {
    if (!stringToSearch || !searchFor) {
        return false;
    }
    return stringToSearch.substr(position, searchFor.length) === searchFor;
}
/**
 * Matches all instances of the RegExp in the string. Operates similarly to the
 * native `String.matchAll`, which is not yet available on all supported
 * browsers. Note that the regex *must* be global.
 */
function matchAll(re, str) {
    const matches = [];
    let match;
    while ((match = re.exec(str))) {
        matches.push(match[1]);
    }
    re.lastIndex = 0;
    return matches;
}
/**
 * Determines if the specified string is undefined, null, empty, or whitespace.
 * True if the value is undefined, null, empty, or whitespace, otherwise false.
 */
export function isNullOrWhiteSpace(value) {
    return !value || !value.trim();
}
const wordRe = /([A-Z]+[a-z0-9]*|[A-Z]*[a-z0-9]+)/g;
/**
 * Converts a string to Pascal Case
 */
export function pascalCase(value) {
    return matchAll(wordRe, value)
        .map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`)
        .join("");
}
/**
 * converts a string from camelCase or pascalCase to spinal-case
 * which is an lowercase dash separated naming style.
 *
 * An example of spinal case: foo-bar-bat
 */
export function spinalCase(value) {
    const valueWithLowerCaseFirstLetter = `${value
        .charAt(0)
        .toLowerCase()}${value.slice(1)}`;
    return valueWithLowerCaseFirstLetter.replace(/([A-Z])/g, function (match, group1) {
        return `-${group1.toLowerCase()}`;
    });
}
